import { get } from "../../utils/httpClient";

const groupService = () => {
  const prefixApi = "duedates/groups";

  const getGroups = async () => {
    return await get(`/${prefixApi}/`);
  };

  const getGroup = async (id) => {
    return await get(`/${prefixApi}/${id}`);
  };

  const getGroupUsers = async (id) => {
    return await get(`/${prefixApi}/${id}/users`);
  };

  return {
    getGroup,
    getGroups,
    getGroupUsers,
  };
};

export default groupService;
